module.exports = __webpack_public_path__ + "static/media/MUTHOOTFIN_F1.1e6a0f45.txt";